/** @deprecated Use the type instead. */
export const StepDirection = {
  NEXT: 'next',
  PREVIOUS: 'previous'
} as const;

export type StepDirection = typeof StepDirection[keyof typeof StepDirection];
